import { render, staticRenderFns } from "./ItemBioPanel.vue?vue&type=template&id=030e09f7&"
import script from "./ItemBioPanel.vue?vue&type=script&lang=js&"
export * from "./ItemBioPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports